import React from 'react';
import { Link } from 'react-router-dom';

import i18n from 'i18n';

import { AgencyListProps } from './AgencyListModel';
import { renderColumn } from 'components/TableColumn/TableColumn';
import styles from './agencyList.module.scss';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import TableRowToolBar from 'containers/TableRowToolBar/TableRowToolBar';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { isRoles } from 'core/permission/PermissionDSL';
import { RoleNames } from 'core';
import { AgencyStatus } from 'core/agency/Agency';
import { compact } from 'lodash';

export class AgencyList extends React.Component<AgencyListProps> {
  nameFormatter = (cell: any, row: any): any => {
    const routePath = this.props.model.routePath;
    return (
      <div className={styles.nameCell}>
        <Link to={`/${routePath}/${cell}`} className={styles.name}>
          {row.name}
        </Link>
        <div className={styles.agencyId}>{`ID: ${cell}`}</div>
      </div>
    );
  };

  statusFormatter = (cell: any): any => {
    return cell === AgencyStatus.ARCHIVED
      ? i18n.t('agencies.status.archived')
      : i18n.t('agencies.status.active');
  };

  floatingEditBtnsFormatter = (cell: any, row: any): any => {
    return (
      <TableRowToolBar className={styles.floatingEditArea}>
        <PermissionChecker permissionAware={isRoles(RoleNames.sysAdmin)}>
          <Link to={`/agencies/${row.id}/edit`}>
            <IconWithTooltip
              icon={faPencilAlt}
              tooltipProps={{
                id: `agencyListEditTip-${row.id}`,
                tooltip: i18n.t('agencyList.labels.editHint')
              }}
            />
          </Link>
        </PermissionChecker>
      </TableRowToolBar>
    );
  };

  render() {
    const model = this.props.model;
    const columns = compact([
      renderColumn(model.nameColumn, this.nameFormatter),
      renderColumn(model.currencyColumn),
      renderColumn(model.timeZoneColumn),
      model.statusColumn
        ? renderColumn(model.statusColumn, this.statusFormatter)
        : undefined,
      model.editBtnsColumn
        ? renderColumn(model.editBtnsColumn, this.floatingEditBtnsFormatter)
        : undefined
    ]);
    return (
      <StickableTanstackTable
        stickLastColumn
        remote={model.onListChange ? true : false}
        keyField='id'
        data={model.agencies}
        columns={columns}
        defaultSorted={model.defaultSorts}
        noDataIndication={i18n.t(model.noDataDescription)}
        pagination={{
          page: model.pagination.page,
          sizePerPage: 10,
          totalSize: model.pagination.totalCount
        }}
        onTableChange={model.onListChange}
      />
    );
  }
}
